export const userFilesClientContext = {
  add: '/media-service/api/external/files',
  delete: '/media-service/api/external/files',
  getAll: '/media-service/api/external/files/info',
  update: '/media-service/api/external/files/{id}',
  getById: '/media-service/api/external/files/info/{id}',
  download: '/media-service/api/external/files/{id}',
};
